import { useEffect, useState } from "react";
import api from "@/lib/api";
import { BrandMark } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function BrandingSection({ settings, refresh }) {
  const [form, setForm] = useState({
    portal_name: settings.portal_name || "",
    portal_tagline: settings.portal_tagline || "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm({
      portal_name: settings.portal_name || "",
      portal_tagline: settings.portal_tagline || "",
    });
  }, [settings.portal_name, settings.portal_tagline]);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/settings", form);
      toast.success("Branding updated");
      await refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
    setSaving(false);
  };

  return (
    <section data-testid="section-branding">
      <h2 className="text-lg font-semibold tracking-tight mb-1" style={{ fontFamily: "Outfit" }}>Branding</h2>
      <p className="text-xs text-slate-500 mb-5">Portal name and tagline shown across the entire app.</p>

      <div className="border border-slate-200 p-5 rounded-sm">
        <div className="flex items-start gap-6">
          <div className="shrink-0 text-center">
            <div className="inline-block">
              <BrandMark size={80} />
            </div>
            <div className="mt-2 text-[10px] text-slate-400 max-w-[140px]">
              Logo is fixed for Griffin Consultancy.
            </div>
          </div>
          <div className="flex-1 space-y-3">
            <div>
              <Label className="text-xs">Portal Name</Label>
              <Input
                value={form.portal_name}
                onChange={(e) => setForm({ ...form, portal_name: e.target.value })}
                placeholder="Griffin Consultancy Pulse"
                className="mt-1 rounded-sm"
                data-testid="input-portal-name"
              />
              <div className="mt-1 text-[10px] text-slate-400">
                The last word is treated as the sub-mark (e.g., "Griffin Consultancy" / <strong>PULSE</strong>).
              </div>
            </div>
            <div>
              <Label className="text-xs">Tagline (fallback when name is a single word)</Label>
              <Input
                value={form.portal_tagline}
                onChange={(e) => setForm({ ...form, portal_tagline: e.target.value })}
                placeholder="Internal Portal"
                className="mt-1 rounded-sm"
                data-testid="input-portal-tagline"
              />
            </div>
            <div>
              <Button onClick={save} disabled={saving} className="bg-[#0a2540] hover:bg-[#0f2f50] rounded-sm" data-testid="btn-save-branding">
                {saving ? "Saving…" : "Save"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
